import React from "react";
import "./contactNew.css";
import projectsData from "../../data/projectsData";

const Contact = () => {
  const contacts = projectsData.contacts;

  return (
    <section className="contact-section" id="contact">
      <h2 className="section-title">CONTACT</h2>
      <p className="contact-intro">
        Connect with Shantanu Basumatary on LinkedIn, GitHub, X, or email for
        full stack and AI collaboration.
      </p>
      <div className="contact-grid">
        {contacts.map((contact) => (
          <a
            key={contact.id}
            href={contact.link}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card"
          >
            <div className="contact-icon">
              <i className={contact.icon} aria-hidden="true"></i>
            </div>
            <div className="contact-info">
              <div className="contact-label">{contact.label}</div>
              <div className="contact-value">{contact.value}</div>
            </div>
            <div className="contact-arrow">→</div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Contact;
